import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js'
function CollectionOp(props) {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [opData, setopData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const handleStartDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setStartDate(localDate);
    };
    const handleEndDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setEndDate(localDate);
    };
    useEffect(() => {
        fetchData();
    }, [startDate, endDate]);
    function fetchData() {
        setIsLoading(true);
        const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
        const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
        const url = `${baseUrl}op-collection-view/?start_date=${startDateString}&end_date=${endDateString}`;
        axios.get(url)
            .then(response => {
                setopData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const rows = opData.filter(item => item.paid > 0).map(item => ({
        id: item.id,
        date_time: `${item.add_date_date} ${item.add_time}`,
        appt_id: item.appt_id,
        pat__pat_id: item.pat__pat_id,
        pat__patient: item.pat__patient,
        invoice: item.invoice,
        fee: item.fee,
        paid: item.paid,
        balance: item.balance,
        mode: item.mode,
        cashier: item.cashier,
    }));
    const columns = [
        {field: 'date_time', headerName: 'Date', width: 170},
        {field: 'appt_id', headerName: 'Appt Id', width: 120},
        {field: 'pat__pat_id', headerName: 'Patient ID', width: 100},
        {field: 'pat__patient', headerName: 'Patient', width: 200},
        {
            field: 'invoice', headerName: 'Invoice No',
            renderCell: (params) => (
                <Link to={`/op-invoice/${params.row.invoice}`} target="_blank">
                    {params.row.invoice}
                </Link>
            ),
            width: 120
        },
        {field: 'fee', headerName: 'Invoiced Amount', width: 100},
        {field: 'paid', headerName: 'Paid Amount', width: 100},
        {field: 'balance', headerName: 'Balance', width: 100},
        {field: 'mode', headerName: 'Payment Mode', width: 110},
        {field: 'cashier', headerName: 'Cashier', width: 100},
    ];
    const getTotal = (rows, field) => {
        return rows.reduce((total, row) => total + parseFloat(row[field]), 0);
    };
    const Footer = ({rows}) => {
        const totalInvoicedAmount = getTotal(rows, 'fee');
        const totalPaidAmount = getTotal(rows, 'paid');
        const totalBalance = getTotal(rows, 'balance');
        return (
            <div style={{display: 'flex', justifyContent: 'space-evenly', padding: '8px'}}>
                <div>Total</div>
                <div>Invoiced Amount: {totalInvoicedAmount}</div>
                <div>Paid Amount: {totalPaidAmount}</div>
                <div>Balance: {totalBalance}</div>
            </div>
        );
    };
    const today = new Date();
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                className="fa-solid fa-calendar-days"
                aria-hidden="true" style={{color: 'red'}}></i> OP Collection Report</h3>
            <div className="row">
                <div className="col-md-6">
                    <label htmlFor="user" className="form-label">Select Date</label>
                    <div className="date-filter-container">
                        <DatePicker
                            selected={startDate}
                            onChange={handleStartDateChange}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText="From Date"
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            className="date-picker-input"
                        />

                        <DatePicker
                            selected={endDate}
                            onChange={handleEndDateChange}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            placeholderText="To Date"
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            className="date-picker-input"
                        />
                    </div>
                </div>
            </div>


            <div style={{height: "100%", width: "100%"}}>
                <DataGrid className="mt-4"
                          sx={{
                              boxShadow: 4,
                              border: 4,
                              borderColor: 'primary.light',
                              '& .MuiDataGrid-cell:hover': {
                                  color: 'primary.main',
                              },
                          }}
                          rows={rows}
                          columns={columns}
                          pageSize={10}
                          slots={{
                              toolbar: GridToolbar,
                          }}
                          autoHeight
                />
                <table className="mt-4" style={{width: '100%', borderCollapse: 'collapse'}}>
                    <tfoot>
                    <Footer rows={rows}/>
                    </tfoot>
                </table>
            </div>
        </section>
    )
}
export default CollectionOp;
